document.addEventListener('DOMContentLoaded', function() {
  function customSlider() {
    document.querySelectorAll('.group-block-content.custom-slider-all').forEach(slider => {
      // Wrap slides in slider-track and add slider-slide class
      const slides = slider.querySelectorAll(':scope > div');
      const track = document.createElement('div');
      track.classList.add('slider-track');
      
      slides.forEach(slide => {
        const slideWrapper = document.createElement('div');
        slideWrapper.classList.add('slider-slide');
        slideWrapper.appendChild(slide);
        track.appendChild(slideWrapper);
      });
      
      slider.innerHTML = ''; // Clear existing content
      slider.appendChild(track);

      // Get settings from CSS variables
      const styles = getComputedStyle(slider);
      const slidesPerView = parseInt(styles.getPropertyValue('--slides-per-view')) || 3;
      const slidesPerViewMobile = parseInt(styles.getPropertyValue('--slides-per-view-mobile')) || 1;
      const gap = parseInt(styles.getPropertyValue('--gap')) || 0;
      
      // Append arrows
      const showArrows = styles.getPropertyValue('--show-arrows').trim() !== 'false';
      if (showArrows) {
        const prevButton = document.createElement('button');
        prevButton.classList.add('slider-arrow', 'prev');
        prevButton.innerHTML = '&larr;';
        slider.appendChild(prevButton);

        const nextButton = document.createElement('button');
        nextButton.classList.add('slider-arrow', 'next');
        nextButton.innerHTML = '&rarr;';
        slider.appendChild(nextButton);
      }

      // Append pagination
      const showPagination = styles.getPropertyValue('--show-pagination').trim() !== 'false';
      if (showPagination) {
        const pagination = document.createElement('div');
        pagination.classList.add('slider-pagination');
        slider.appendChild(pagination);
      }

      // Slider logic
      const trackElement = slider.querySelector('.slider-track');
      const slideElements = slider.querySelectorAll('.slider-slide');
      let currentIndex = 0;
      let isDragging = false;
      let startPos = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID = null;

      // Initialize slider
      function initSlider() {
        const slidesPerViewCurrent = getCurrentSlidesPerView();
        const slideWidth = (100 / slidesPerViewCurrent);
        
        // Set slide widths
        slideElements.forEach(slide => {
          slide.style.flex = `0 0 ${slideWidth}%`;
          slide.style.maxWidth = `${slideWidth}%`;
          slide.style.paddingLeft = `${gap / 2}px`;
          slide.style.paddingRight = `${gap / 2}px`;
        });
        
        // Set track width
        trackElement.style.width = `${slideElements.length * 100}%`;
        
        updateSlider();
        createPagination();
      }

      function getCurrentSlidesPerView() {
        return window.innerWidth <= 640 ? slidesPerViewMobile : slidesPerView;
      }

      function updateSlider() {
        const slidesPerViewCurrent = getCurrentSlidesPerView();
        const slideWidth = (100 / slidesPerViewCurrent);
        const offset = -(currentIndex * slideWidth);
        
        trackElement.style.transition = isDragging ? 'none' : 'transform 0.5s ease';
        trackElement.style.transform = `translateX(${offset}%)`;
        prevTranslate = offset;

        // Update active dot
        if (showPagination) {
          const dots = slider.querySelectorAll('.slider-dot');
          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
          });
        }

        // Disable buttons at bounds
        if (showArrows) {
          const prevButton = slider.querySelector('.slider-arrow.prev');
          const nextButton = slider.querySelector('.slider-arrow.next');
          prevButton.disabled = currentIndex === 0;
          nextButton.disabled = currentIndex >= Math.ceil(slideElements.length / slidesPerViewCurrent) - 1;
        }
      }

      function createPagination() {
        if (!showPagination) return;
        
        const pagination = slider.querySelector('.slider-pagination');
        pagination.innerHTML = '';
        
        const slidesPerViewCurrent = getCurrentSlidesPerView();
        const totalPages = Math.ceil(slideElements.length / slidesPerViewCurrent);
        
        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement('button');
          dot.classList.add('slider-dot');
          if (i === 0) dot.classList.add('active');
          dot.addEventListener('click', () => goToPage(i));
          pagination.appendChild(dot);
        }
      }

      function goToPage(index) {
        currentIndex = Math.max(0, Math.min(index, Math.ceil(slideElements.length / getCurrentSlidesPerView()) - 1));
        updateSlider();
      }

      // Touch/mouse event handlers
      function startDrag(e) {
        isDragging = true;
        startPos = getPositionX(e);
        currentTranslate = prevTranslate;
        trackElement.style.transition = 'none';
        slider.style.cursor = 'grabbing';
      }

      function drag(e) {
        if (!isDragging) return;
        e.preventDefault();
        
        const currentPos = getPositionX(e);
        const diff = currentPos - startPos;
        const translateX = currentTranslate + (diff / slider.offsetWidth * 100);
        
        trackElement.style.transform = `translateX(${translateX}%)`;
      }

      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = 'grab';
        
        const movedBy = (parseFloat(trackElement.style.transform.replace('translateX(', '').replace('%)', '')) - prevTranslate) / (100 / getCurrentSlidesPerView());
        
        if (Math.abs(movedBy) > 0.3) {
          currentIndex += movedBy > 0 ? -1 : 1;
        }
        
        goToPage(currentIndex);
      }

      function getPositionX(e) {
        return e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      }

      // Event listeners
      trackElement.addEventListener('mousedown', startDrag);
      trackElement.addEventListener('touchstart', startDrag, { passive: false });
      window.addEventListener('mousemove', drag);
      window.addEventListener('touchmove', drag, { passive: false });
      window.addEventListener('mouseup', endDrag);
      window.addEventListener('touchend', endDrag);
      
      if (showArrows) {
        slider.querySelector('.slider-arrow.prev').addEventListener('click', () => goToPage(currentIndex - 1));
        slider.querySelector('.slider-arrow.next').addEventListener('click', () => goToPage(currentIndex + 1));
      }

      // Handle window resize
      function handleResize() {
        initSlider();
      }
      
      window.addEventListener('resize', handleResize);
      
      // Initialize
      initSlider();
    });
  }

  // Run slider only on mobile if needed
  let mql = window.matchMedia("(max-width: 810px)");
  function handleMobileChange(e) {
    if (e.matches) {
      customSlider();
    }
  }
  mql.addListener(handleMobileChange);
  handleMobileChange(mql);
});